import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface TutorialItem {
  title: string;
  description: string;
  actions?: string[];
}

@Component({
  selector: 'app-tutorial-dialog',
  templateUrl: './tutorial-dialog.component.html',
  styleUrls: ['./tutorial-dialog.component.scss']
})
export class TutorialDialogComponent {
  dontShow = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { items: TutorialItem[]; title?: string },
    private dialogRef: MatDialogRef<TutorialDialogComponent>
  ) {}

  close() {
    this.dialogRef.close(this.dontShow);
  }
}
